export default {"src":"/_next/static/media/parking-lot-fill.04f864f4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};